import classnames from 'classnames';
import { IconProps } from '../types';

/**
 * The Pix mark, from Shopify's MIT-licensed payment_icons pack
 * (activemerchant/payment_icons). Kept as the scheme ships it, frame included.
 */
export default function PixIcon(props: IconProps) {
  const { className, style } = props;

  return (
    <svg className={classnames('h-5', className)} viewBox="0 0 38 24" style={style} role="img" aria-label="Pix">
      <g clipPath="url(#pi-pix-a)">
        <path
          fill="#000"
          d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3Z"
          opacity=".07"
        />
        <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32Z" />
        <path
          fill="#939598"
          fillRule="evenodd"
          d="M18.125 8.246c-1.202 0-2.162.937-2.162 2.077v6.882a.216.216 0 1 1-.431 0v-6.882c0-1.393 1.168-2.509 2.593-2.509l2.107.003c1.42.003 2.585 1.117 2.585 2.505v1.465c0 1.393-1.169 2.509-2.594 2.509h-2.977a.216.216 0 0 1 0-.432h2.977c1.202 0 2.162-.937 2.162-2.077v-1.465c0-1.136-.956-2.07-2.154-2.073l-2.106-.003Zm4.849-.216c0-.12.096-.217.216-.217h.914c.313 0 .615.12.84.337.224.216.35.51.35.82v5.14a.216.216 0 1 1-.43 0V8.97a.708.708 0 0 0-.22-.51.778.778 0 0 0-.54-.215h-.914a.216.216 0 0 1-.216-.216Z"
          clipRule="evenodd"
        />
        <path
          fill="#32BCAD"
          d="m24.883 7.233-.414-.4a.255.255 0 0 1-.077-.18.247.247 0 0 1 .077-.18l.414-.399a.269.269 0 0 1 .373 0l.414.4a.252.252 0 0 1 .077.18.247.247 0 0 1-.077.18l-.414.399a.263.263 0 0 1-.186.074.272.272 0 0 1-.187-.074Z"
        />
        <path
          stroke="#939598"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth=".432"
          d="M26.833 8.025h.906c.466 0 .913.178 1.243.496l2.12 2.045a.705.705 0 0 0 .497.198.726.726 0 0 0 .498-.198l2.112-2.037c.33-.318.777-.497 1.243-.497h.737"
        />
        <path
          fill="#939598"
          fillRule="evenodd"
          d="M31.6 11.542a.51.51 0 0 0-.348.138l-2.12 2.045c-.37.357-.872.557-1.393.557h-.906a.216.216 0 1 1 0-.432h.906a1.57 1.57 0 0 0 1.093-.436l2.12-2.044a.92.92 0 0 1 .647-.26.942.942 0 0 1 .647.26m0 0 2.113 2.037c.288.278.682.436 1.093.436h.737a.216.216 0 1 1 0 .431h-.737c-.52 0-1.022-.2-1.393-.557l-2.112-2.037a.489.489 0 0 0-.348-.138"
          clipRule="evenodd"
        />
        <path
          fill="#32BCAD"
          d="M10.343 15.372c-.454 0-.882-.17-1.204-.48l-1.74-1.678a.34.34 0 0 0-.456 0l-1.745 1.683a1.698 1.698 0 0 1-.553.357 1.746 1.746 0 0 1-.652.124H3.65l2.203 2.124a1.808 1.808 0 0 0 2.491 0l2.209-2.13h-.21ZM3.993 9.44c.455 0 .883.17 1.205.48l1.745 1.684a.33.33 0 0 0 .457 0l1.739-1.677a1.714 1.714 0 0 1 1.204-.481h.21l-2.209-2.13a1.808 1.808 0 0 0-2.491 0L3.65 9.44h.343Z"
        />
        <path
          fill="#32BCAD"
          d="M12.38 11.208 11.045 9.92a.262.262 0 0 1-.095.018h-.607c-.315 0-.618.122-.842.337l-1.74 1.677a.833.833 0 0 1-.59.235.859.859 0 0 1-.59-.235L4.836 10.27a1.222 1.222 0 0 0-.843-.337h-.746a.26.26 0 0 1-.09-.017l-1.34 1.292a1.656 1.656 0 0 0 0 2.402l1.34 1.293a.259.259 0 0 1 .09-.018h.746c.316 0 .619-.122.843-.337l1.745-1.683a.878.878 0 0 1 1.18 0l1.74 1.677c.224.215.527.336.842.337h.607c.034 0 .066.007.095.019l1.335-1.288a1.656 1.656 0 0 0 0-2.402"
        />
      </g>
      <defs>
        <clipPath id="pi-pix-a">
          <path fill="#fff" d="M0 0h38v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
